<div class="m-subheader">
  <div class="d-flex align-items-center">
    <div class="mr-auto">
      <h3 class="m-subheader__title">
        {{ 'suppliers-list.title' | transloco }}
      </h3>
    </div>
    <div>
      <app-suppliers-new [id]="supplierId" (update)="updater($event)"></app-suppliers-new>
    </div>
  </div>
</div>

<div class="m-content">
  <div class="row">
    <div class="col-sm-12">
      <div class="m-portlet m-portlet--full-height">
        <div class="m-portlet__body">
          <div class="hx-filters">
            <div class="filter">
              <small>{{ 'suppliers-list.city' | transloco }}</small>
              <ng-select [(ngModel)]="params.countryId" (change)="applyFilters()">
                <ng-option *ngFor="let c of countries" [value]="c.id">{{c.title | uiLabel}}</ng-option>
              </ng-select>
            </div>

            <div class="filter">
              <small>{{ 'suppliers-list.searchName' | transloco }}</small>
              <input type="text" required [(ngModel)]="params.query" (keyup)="onQueryChanged()" name="query" class="form-control m-input">
            </div>
          </div>

          <div class="row" style="text-align: right">
            <div class="col-md-12">
              <button type="button" (click)="resetFilter()" class="btn btn-outline-primary">
                <span>{{ 'reset.list' | transloco }}</span>
              </button>
            </div>
          </div>

          <div class="table-responsive m-datatable--va-top m-datatable m-datatable--default m-datatable--loaded m--margin-top-20 m--margin-bottom-30" *ngIf="list.length && !isLoading.list">
            <table class="m-datatable__table">
              <thead class="m-datatable__head">
                <tr class="m-datatable__row m-datatable__row--head">
                  <th class="m-datatable__cell" style="min-width: 120px;">
                    <span>{{ 'suppliers-list.name' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'suppliers-list.description' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell">
                    <span>{{ 'suppliers-list.document' | transloco }}</span>
                  </th>
                  <th class="m-datatable__cell text-right">
                    <span>{{ 'suppliers-list.events' | transloco }}</span>
                  </th>
                </tr>
              </thead>
              <tbody class="m-datatable__body">
                <tr *ngFor="let even = even; let i = index; let item of list"
                  class="m-datatable__row" [ngClass]="{ 'm-datatable__row--even': even }">
                  <td class="m-datatable__cell">
                    <span>{{ item.name }}</span>
                  </td>
                  <td class="m-datatable__cell">
                    <span>{{ item.description }}</span>
                  </td>
                  <td class="m-datatable__cell">
                    <span>{{ item.uin }}</span>
                  </td>
                  <td class="m-datatable__cell text-nowrap text-right" style="min-width: 102px;">
                    <a (click)="updateItem(item)" class="btn btn-outline-primary btn-sm m-btn m-btn--icon" [title]="'suppliers-list.change' | transloco">
                      <i class="la la-edit"></i>
                    </a>

                    <a (click)="deleteItem(item.id)" class="btn btn-outline-danger m-btn btn-sm m-btn--icon" [title]="'suppliers-list.deleteBank' | transloco">
                      <i class="la la-trash"></i>
                    </a>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>

          <hx-loader [length]="list.length" [isLoading]="isLoading.list"></hx-loader>

          <div class="m--align-center" *ngIf="list.length && !isLoading.list && pagination.allItemCount > 0">
            <ngb-pagination [maxSize]="5" [rotate]="true" [collectionSize]="pagination.allItemCount"
                            [(page)]="pagination.currentPage" [pageSize]="pagination.limit" (pageChange)="pageChanged($event)" class="d-flex justify-content-center mt-4">
            </ngb-pagination>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
